const orderApproveEncryptionType = {
  // 申请人
  proposer: {
    eyeOwner: 'proposer', // 小眼睛持有者
    idno: 'idno', // 贷款申请人身份证
    mobile: 'mobile' // 贷款申请人手机号
  },
  eContactMobile: 'eContactMobile', // 紧急联系人手机号
  eContactsMobile: 'eContactsMobile', // 紧急联系人2手机号
  carIdentify: 'carIdentify', // 车辆识别号
  carSaleIdno: 'carSaleIdno', // 二手车卖方身份证
  repAccountIdno: 'repAccountIdno', // 还款人证件号码
  repAccountNo: 'repAccountNo', // 借记卡号
  repAccountMobile: 'repAccountMobile', // 银行卡预留手机号
  // 担保人
  guarantee: {
    eyeOwner: 'guarantee', // 小眼睛持有者
    idno: 'idno', // 担保人身份证
    mobile: 'mobile' // 担保人手机号
  },
  // 配偶
  relative: {
    eyeOwner: 'relative', // 小眼睛持有者
    idno: 'idno', // 配偶身份证
    mobile: 'mobile' // 配偶手机号
  },
  recAccountNo: 'recAccountNo', // 收款借记卡号
  recAccountCard: 'recAccountCard' // 收款人证件号码
}

export {
  orderApproveEncryptionType
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.page.encryption.js